import { useState, useEffect } from "react";
import Api from "../../utils/Api";
import {
  API_ROUTE_UPDATE_THRESHOLD,
  API_ROUTE_UPDATE_THRESHOLD_CHANNELS,
} from "../../routes";

export default function useUpdateThreshold(auto = false) {
  const [isLoading, setIsLoading] = useState(false);
  const [threshold, setThreshold] = useState(0);
  const [thresholdChannels, setThresholdChannels] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [messageType, setMessageType] = useState("success");

  const getThreshold = () => {
    Api.get(API_ROUTE_UPDATE_THRESHOLD)
      .then(function (response) {
        setThreshold(response.data.threshold);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const updateThreshold = (threshold) => {
    Api.put(API_ROUTE_UPDATE_THRESHOLD, {
      threshold,
    })
      .then(() => {
        setMessageType("success");
        setOpenSnackbar(true);
      })
      .catch(() => {
        setMessageType("error");
        setOpenSnackbar(true);
      });
  };

  const getThresholdChannels = () => {
    Api.get(API_ROUTE_UPDATE_THRESHOLD_CHANNELS)
      .then(function (response) {
        setThresholdChannels(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const updateThresholdChannels = (thresholds) => {
    setIsLoading(true);

    Api.put(API_ROUTE_UPDATE_THRESHOLD_CHANNELS, thresholds)
      .then(function (response) {
        setMessageType("success");
        setOpenSnackbar(true);
      })
      .catch(function (error) {
        setMessageType("error");
        setOpenSnackbar(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (!auto) {
      return;
    }
    getThreshold();
    getThresholdChannels();
  }, [auto]);

  return {
    isLoading,
    threshold,
    thresholdChannels,
    messageType,
    openSnackbar,
    setOpenSnackbar,
    setThreshold,
    getThreshold,
    updateThreshold,
    setThresholdChannels,
    getThresholdChannels,
    updateThresholdChannels,
  };
}
